import * as React from 'react'
import * as ReactRedux from 'react-redux'
import * as ReactRouter from 'react-router-dom'

import * as Configuration from './configuration'
import { useMenuQueries } from './use-menu-queries'

export function usePnPRedirect() {
  const { pnpLoginDepositQuery } = useMenuQueries()
  const history = ReactRouter.useHistory()
  const isPnPEnabled = ReactRedux.useSelector(state =>
    Configuration.getPnPEnabled(state.configuration)
  )

  const shouldRedirectToPnp =
    isPnPEnabled &&
    (history?.location?.search.includes('login=me') ||
      history?.location?.search.includes('register=me'))

  React.useEffect(() => {
    if (shouldRedirectToPnp) {
      history.push(`?${pnpLoginDepositQuery}`)
    }
  }, [shouldRedirectToPnp])
}
